import { MatDialogConfig } from "@angular/material/dialog";

export const dialogConfig: MatDialogConfig = {
  panelClass: "l-loading-dialog",
  maxWidth: 375,
  width: "100%",
  disableClose: true,
};
